import { useTranslation } from 'react-i18next';
import { Toast } from './Toast';
import { PdfDownloadToastState } from '../../../utils';

type Props = {
    state: PdfDownloadToastState;
    onClose: () => void;
};

/**
 * Renders the toast for the PDF backend-download flow. Encapsulates the
 * heading-key / toast-type derivation so callers don't have to repeat it.
 */
export const PdfDownloadToast = ({ state, onClose }: Props) => {
    const { t } = useTranslation();

    if (!state.open) {
        return null;
    }

    const headingKey =
        state.type === 'error'
            ? 'PDF_DOWNLOAD_ERROR'
            : state.type === 'confirm'
            ? 'PDF_DOWNLOAD_SUCCESS'
            : 'PDF_BEING_GENERATED';

    const toastType = state.type === 'error' ? 'error' : state.generating ? 'alert' : 'confirm';

    return (
        <Toast
            heading={t(headingKey)}
            type={toastType}
            messages={[]}
            handleClose={onClose}
            isTimer={!state.generating}
            disappearTime={state.generating ? undefined : 3}
            disabled={false}
        />
    );
};
